import { render, staticRenderFns } from "./WebModal.vue?vue&type=template&id=b96491a2"
import script from "./WebModal.vue?vue&type=script&lang=js"
export * from "./WebModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports